import { Outlet, useLocation } from 'react-router-dom';
import { AmbientBackground } from '@/components/layout/AmbientBackground';
import { SiteFooter } from '@/components/layout/SiteFooter';
import { UpcomingReleases } from '@/components/layout/UpcomingReleases';
import { TopNav } from '@/components/layout/TopNav';
import type { HubCategory } from '@/types';

interface AppShellProps {
  categories?: HubCategory[];
  activeCategory?: string;
  onCategoryChange?: (categoryId: string) => void;
}

export function AppShell({
  categories = [],
  activeCategory,
  onCategoryChange,
}: AppShellProps) {
  const { pathname } = useLocation();
  /* The release rail is a landing teaser; deeper pages carry their own lists. */
  const showUpcoming = pathname === '/';

  return (
    <div className="app-shell">
      <AmbientBackground />
      <TopNav
        categories={categories}
        activeCategory={activeCategory}
        onCategoryChange={onCategoryChange}
      />
      <main className="app-main">
        <Outlet />
      </main>
      {showUpcoming ? <UpcomingReleases /> : null}
      <SiteFooter />
    </div>
  );
}
